import { configureStore } from '@reduxjs/toolkit'
import signInReducer from '../features/authentication/signIn';

export const store = configureStore({
  reducer: {
    signedIn: signInReducer,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
